<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Inventaire</h1>
                    <p>Gestion des stocks</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.inventory.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un inventaire</span>
                </li>
                <li @click="clearCart()">
                  <icon name="refresh-cw-05"/>
                  <span>Supprimer les paniers actifs</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabs" active-advanced-filter="false" active-tabs="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div>
                          <datagrid-sort :data="[{name:'Référence', value:'internal_identifier'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Disponibilité', value:'available_at'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Expiration', value:'expiration_date'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'Qté initiale', value:'quantity'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="center"><span>En stock</span></div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'Dans le panier', value:'in_cart'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div><span>Scopes</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.inventory.view', item.id )">
                        <div></div>
                        <div class="picture no-radius">
                            <figure>
                                <icon name="package"/>
                            </figure>
                        </div>
                        <div data-field="internal_identifier">
                            <strong class="highlight">{{ item.internal_identifier }}</strong>
                            <p>{{ item.name }}</p>
                            <span class="label expired_soon" v-if="item.in_order > 0" style="margin-top: 0.5em;">{{ parseInt(item.in_order) }} pièce(s) en attente de paiement</span>
                        </div>
                        <div data-field="available_at">
                            <date v-model="item.available_at" v-if="item.available_at"></date>
                            <span v-else-if="item.shipping_delay > 0">Sous {{ item.shipping_delay }}H</span>
                            <span v-else>Immédiate</span>
                        </div>
                        <div data-field="expiration_date" class="center">
                            <span v-if="item.has_expired == null">-</span>
                            <span class="label" v-bind:class="{'published':item.has_expired > 190,'soon':item.has_expired > 30 && item.has_expired <= 190, 'expired':item.has_expired <= 30}" v-else="item.has_expired != null && item.has_expired > 365"><date v-model="item.expiration_date"></date></span>
                        </div>
                        <div data-field="quantity" class="center"><span class="label" >{{ parseInt(item.quantity) }}</span></div>
                        <div data-field="quantity" class="center">
                          <span class="label" v-bind:class="{'published':item.percentage_available > 50, 'expired_soon':item.percentage_available > 30 && item.percentage_available <= 50, 'expired':item.percentage_available <= 30}">{{ (item.quantity - item.sales - item.in_order - item.in_cart) }}</span>
                        </div>
                        <div data-field="in-cart" class="center"><span class="label">{{ parseInt(item.in_cart) }}</span></div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul v-if="paginator.filter == 'only_trashed'">
                                <li><button @click="restore(item.id)"><i class="icon icon-icon_refresh"></i></button></li>
                            </ul>
                            <ul v-else>
                                <li v-if="$aclInterfaceValidator('weeboxshop.inventory.delete', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.inventory.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import InventoryService from './InventoryService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                tabs: [
                    {
                        slug: '',
                        name: 'En cours'
                    },
                    {
                        slug: 'only_trashed',
                        name: 'Corbeille'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return InventoryService;
            },
            clearCart: function(){
                InventoryService.clearCart().then(response => {
                    console.log("ClearCart", response)
                    alert(response.data.deleted + " produit(s) supprimé(s)")
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/inventory/Index.vue